import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' },
      ]
    },
    cellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid cell phone number.' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
       },
    eventextra5: {
      validations: []
    },
    category: {
      validations: [        
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' },
      ]
      },
    accountextra7: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    notes: {
      validations: []
    },
  reference: {
    validations: [
      { type: 'required', message: 'Please fill in required field' },
    ]
  }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone #:*',
            mapping: 'cellNumber'
          }
        ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'If you’re planning a wedding, what is your spouse’s first and last name?:',
            mapping: 'eventextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Select Your Catering Service:*',
             options: [
              { label: 'Full-Service Catering – For weddings, galas, and formal events. Includes china, flatware, linens, and staff.', value: 'Full-Service Catering.'},
              { label: 'Disposable Drop-Off – Perfect for corporate meetings and casual events. Delivered in disposable containers.', value: 'Disposable Drop-Off.'},
              { label: 'Picnic Catering – Ideal for summer picnics, family reunions, and graduation parties.', value: 'Picnic Catering.'},
              { label: 'Not Sure – Let’s discuss the best option for your event.', value: 'Not Sure'},
            ],
            mapping: 'category'
          }
        ]
      },  
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventdate'
          }
        ]
      },  
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Category:*',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme'
          }
        ]
      },  
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:*',
            mapping: 'plannedguestcount'
          }
        ]
      },  
      {
        fields: [
          {
        type: 'text',
        size: 'Medium',
        label: 'Budget:*',
        mapping: 'accountextra7'
      }
    ]
  },
  {
    fields: [
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Venue:*',
        options: [
          { label: 'Nicollet Island Pavilion', value: 'Nicollet Island Pavilion'},
          { label: 'Solar Arts', value: 'Solar Arts'},
          { label: 'Minnesota Boat Club', value: 'Minnesota Boat Club'},
          { label: 'Inwood Oaks', value: 'Inwood Oaks'},
          { label: 'Leopold’s Mississippi Gardens', value: 'Leopold’s Mississippi Gardens'},
          { label: 'Van Dusen Mansion', value: 'Van Dusen Mansion'},
          { label: 'Undecided', value: 'Undecided'},
          { label: 'Other Venue, type in the name of your venue below', value: 'Other Venue, type in the name of your venue below'},
        ],
        mapping: 'sitename'
      }
    ]
  },
  {
    fields: [
      {
        type: 'text-area',
        size: 'XLarge',
        label: 'Please tell us more about how we can help you!:',
        mapping: 'notes'
      }
    ]
  },
  {
    fields: [
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:*',
            options: [
              { label: 'Current Client Referral', value: 'Current Client Referral' },
              { label: 'Event Planner', value: 'Event Planner' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Google', value: 'Google' },
              { label: 'Guest at Past Event', value: 'Guest at Past Event' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'The Knot', value: 'The Knot' },
              { label: 'Meet Minneapolis', value: 'Meet Minneapolis' },
              { label: 'MN Bride', value: 'MN Bride' },
              { label: 'Other', value: 'Other' },
              { label: 'Other Social Media', value: 'Other Social Media' },
              { label: 'Pinterest', value: 'Pinterest' },
              { label: 'Repeat Client', value: 'Repeat Client' },
              { label: 'Tiktok', value: 'Tiktok' },
              { label: 'Vendor Referral', value: 'Vendor Referral' },
              { label: 'Venue Referral', value: 'Venue Referral' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'Zola', value: 'Zola' },
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Mintahoe Catering & Events Events Form',
    formId: '2086',
    clientKey: 'DA7DAEBE-60B6-441C-AC15-75F22546A5EB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. A member of our sales team will reach out to you within 2 business days.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

export default FormStructure;
